import { render, staticRenderFns } from "./MnvDataTable.vue?vue&type=template&id=3759db22&scoped=true"
import script from "./MnvDataTable.vue?vue&type=script&lang=js"
export * from "./MnvDataTable.vue?vue&type=script&lang=js"
import style0 from "./MnvDataTable.vue?vue&type=style&index=0&id=3759db22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759db22",
  null
  
)

export default component.exports